module.exports = __webpack_public_path__ + "static/media/b2.4da28b22.jpg";